import * as moment from 'moment';
export class BusinessDetailedInteractionsKpi {
    public dateUtc?: moment.Moment;
    public totalUsersCount: number | null = null;
    public totalImpresionsCount: number | null = null;
    public totalUserInteractionsCount: number = 0;
    public totalContactsPhoneCount: number | null = null;
    public totalLocationsMapCount: number | null = null;
    public totalContactsEmailCount: number | null = null;
    public totalContactsWhatsappCount: number | null = null;
    public totalVisitsFacebookCount: number | null = null;
    public totalVisitsInstagramCount: number | null = null;
    public totalVisitsTwitterCount: number | null = null;
    public totalVisitsYoutubeCount: number| null = null;
    public totalVisitsPinterestCount: number | null = null;
    public totalVisitsLinkedinCount: number | null = null;
    public totalVisitsMyWebsiteCount: number | null = null;
    public totalVisitsTikTokCount: number | null = null;
    public totalVisitsTelegramCount: number | null = null;
    public totalSharedCount: number | null = null;
    public totalSavedContactCount: number | null = null;
    public totalReadsQRCodeCount: number | null = null;
    public totalClicksToUserContentLinksCount: number | null = null;
    public totalVisitsMyOnlineShopCount: number | null = null;

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json, {
            dateUtc: moment.utc(json.dateUtc)
        });
    }
}
